import 'izitoast/dist/css/iziToast.min.css'
import iZtoast from 'izitoast'
import i18n from '@/traductions/config'

// Notification tool
const toastr = {
  error: (message, title = i18n.t('status.error')) => {
    return iZtoast.error({
      title: title,
      message: message,
      position: 'topRight'
    })
  },
  success: (message, title = i18n.t('status.success')) => {
    return iZtoast.success({
      title: title,
      message: message,
      position: 'topRight'
    })
  },
  warning: (message, title = i18n.t('status.warning')) => {
    return iZtoast.warning({
      title: title,
      message: message,
      position: 'topRight'
    })
  }
}

export default toastr



// WEBPACK FOOTER //
// ./src/toastr.js